var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.headerLinks),function(headerLink,key){return _c('li',[_c('SfLink',{key:key,attrs:{"link":headerLink.src,"title":headerLink.title}},[_vm._v("\n      "+_vm._s(headerLink.title)+"\n    ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }